/**
 * @todo All the code below must be removed and refactored once the new recipe object is implemented and fields
 * become web components
 */
import './_legacy-add-action';
import { getActions } from '@builder-legacy/item/actions/utilities';
import { getDOMElements } from '@builder-legacy/common/utilities';
import ConditionsBlock from '@builder-legacy/item/conditions/conditions-block';

// Import components
import './add-loop-button';
import './filters';
import './menu-button/delete';
import './menu-button/support';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
const { isEmpty } = _uo.utility;

// Import style for web component
import styles from './web-component-style.scss';

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.itemLoop;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-loop' )
export class AutomatorBuilderItemLoop extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The unique ID of this loop block
	@property( { type: Number, attribute: 'loop-id' } ) id;

	// The logic of the block (intersection|union)
	@property( { type: String, attribute: 'loop-logic' } ) logic;

	// The loop filters
	@property( { type: Array, attribute: false } ) loopFilters = [];

	// The items inside the loop block
	@property( { type: Array, attribute: false } ) items = [];

	// Information about what has to be iterated (e.g. users, posts, tokens)
	@property( { type: Object, attribute: false } ) iterableExpression;

	// Information about the user selector of the loop, if needed
	@property( { type: Object, attribute: false } ) runOn;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="loop">
				${ this._templateSummary }
				${ this._templateItems }
				${ this._templateActions }
			</div>
		`;
	}

	/**
	 * Renders the summary of the loop, which contains the iterable expression and the loop options
	 *
	 * @return {TemplateResult} The summary
	 */
	get _templateSummary() {
		return html`
			<div class="loop-summary">
				${ this._templateHeader }

				<uap-builder-item-loop-filters
					loop-id=${ this.id }
					
					.iterableExpression=${ this.iterableExpression }
					.loopFilters=${ this.loopFilters }
				></uap-builder-item-loop-filters>
			</div>
		`;
	}

	/**
	 * Renders the header of the loop
	 *
	 * @return {TemplateResult} The header
	 */
	get _templateHeader() {
		return html`
			<div class="loop-header">
				<div class="loop-header-info">
					<div class="loop-header-icon">
						<uo-icon id="repeat"></uo-icon>
					</div>
					<div class="loop-header-name">
						${ strings.loop }
					</div>
					
					${ this._templateIterableExpression }

					${ this.loopFilters.length > 0 ? html`
						<div class="loop-header-sentence">
							${ strings.matchCriteria }
						</div>
					` : '' }
				</div>
				
				${ this._templateMenu }
			</div>
		`;
	}

	/**
	 * Creates the template of the menu with the loop options (delete, support, etc.)
	 *
	 * @return {TemplateResult|undefined} The menu with the item options, such as "Delete"
	 */
	get _templateMenu() {
		if ( isEmpty( this.menuItems ) ) {
			return;
		}

		return html`
			<div class="loop-header-menu">
				<uo-button-dropdown reverse-direction>
					<uo-button 
						slot="target" 
						color="transparent"
						size="small"
					>
						<uo-icon id="ellipsis-h"></uo-icon>
					</uo-button>

					${ repeat(
						this.menuItems,
						( item, index ) => index,
						item => item
					) }

				</uo-button-dropdown>
			</div>
		`;
	}

	/**
	 * Renders the select used to select what's the data that has to be iterated
	 *
	 * @return {TemplateResult|undefined} The select
	 */
	get _templateIterableExpression() {
		if ( this.iterableExpression.type === 'users' ) {
			return html`
				<div class="loop-header-iterable-expression">
					<uo-chip>
						<uo-icon id="user"></uo-icon> ${ strings.users }
					</uo-chip>
				</div>
			`;
		}

		if ( this.iterableExpression.type === 'posts' ) {
			return html`
				<div class="loop-header-iterable-expression">
					<uo-chip>
						<uo-icon id="files"></uo-icon> ${ strings.posts }
					</uo-chip>
				</div>
			`;
		}
	}

	/**
	 * Renders the loop items, including action filters and actions
	 *
	 * @return {TemplateResult} The items
	 */
	get _templateItems() {

		/**
		 * @todo Uncomment this once the new recipe object is implemented, and fields are moved to web
		 * components.
		 */
		return html`<slot></slot>`;

		// return html`
		// 	<div class="loop-items">
		// 		${ repeat(
		// 			this.items,
		// 			item => item.id,
		// 			item => {
		// 				if ( item.type === 'filter' ) {
		// 					return html`
		// 						<uap-builder-item-filter
		// 							filter-id=${ item.id }
		// 							filter-logic=${ item.logic }

		// 							.conditions=${ item.conditions }
		// 							.items=${ item.items }
		// 						></uap-builder-item-filter>
		// 					`;
		// 				}

		// 				if ( item.type === 'action' ) {
		// 					return html`
		// 						<uap-builder-item-action
		// 							item-id=${ item.id }
		// 							item-code=${ item.code }
		// 							integration-code=${ item.integration_code }

		// 							?is-item-on=${ item.is_item_on }
		// 							?uses-credit=${ item.miscellaneous.uses_credit }

		// 							.fields=${ item.fields }
		// 							.tokens=${ item.tokens }
		// 							.backup=${ item.backup }
		// 						></uap-builder-item-action>
		// 					`;
		// 				}
		// 			}
		// 		) }
		// 	</div>
		// `;
	}

	/**
	 * Renders the loop actions (not items). This contains the "Add action" and "Add filter" buttons
	 *
	 * @return {TemplateResult} The loop actions
	 */
	get _templateActions() {
		return html`
			<div class="loop-actions">
				<uo-button 
					color="secondary" 
					size="small"
					@click=${ this.__deprecated__startAddActionProcess }
				>${ strings.addAction }</uo-button>

				<ua-builder-conditions-add-button 
					parent-id="${ this.id }"
					size="small"
				>
					${ strings.addFilter }
				</ua-builder-conditions-add-button>
			</div>
		`;
	}

	/**
	 * The items/actions displayed in the menu (ellipsis icon)
	 *
	 * @return {Array} An array of TemplateResult, each one representing an action
	 */
	get menuItems() {
		return [
			html`
				<uap-builder-loop-menu-button-delete loop-id=${ this.id }>
				</uap-builder-loop-menu-button-delete>
			`,
			html`
				<uap-builder-loop-menu-button-support>
				</uap-builder-loop-menu-button-support>
			`
		];
	}

	/**
	 * @todo All the code below must be removed and refactored once the new recipe object is implemented and fields
	 * become web components
	 */

	/**
	 * Render the loop items by adding them to the light DOM
	 *
	 * @deprecated This method is deprecated and will be removed once the new recipe object is implemented
	 */
	firstUpdated() {
		// Create inner structure
		this.insertAdjacentHTML( 'beforeEnd', `
			<div>
				<div class="uap-builder-item-loop-items uap-builder-item-loop-items--instant"></div>
				<div class="uap-builder-item-loop-items uap-builder-item-loop-items--delayed"></div>
				<div class="uap-builder-item-loop-items uap-builder-item-loop-items--scheduled"></div>
			</div>
		` );

		// Render the items
		this.__deprecated__renderItems();

		// Render conditions
		this.__deprecated_renderActionFilters();
	}

	/**
	 * Renders the items inside the loop block using the old/deprecated method
	 *
	 * @deprecated This method is deprecated and will be removed once the new recipe object is implemented
	 */
	__deprecated__renderItems() { // eslint-disable-line camelcase
		/**
		 * Step 1: Get all the actions inside this loop, including actions inside the [action] filters
		 */

		/**
		 * This function receives an array of objects and returns an array of *actions* (item type) contained in this array,
		 * but only if the actions are nested inside 'loop' or 'filter' items. It also converts the new format
		 * to the old format.
		 *
		 * @deprecated This function is only used to convert the new recipe object to the old one until the new
		 * recipe object is implemented.
		 * @todo Remove this once the new recipe object is implemented.
		 * @param {Array} recipePart - The array of items to process
		 * @return {Array} - The array of action items
		 */
		const extractNestedActions = ( recipePart ) => {
			// Initialize an empty array to hold the actions
			let actions = [];

			// Loop over each item in the array
			recipePart.forEach( recipePartItem => {
				if ( recipePartItem.type === 'action' ) {
					actions.push( recipePartItem );
				}

				// If the item is a loop or a filter and has nested items, recursively call extractNestedActions on the nested items
				if (
					( recipePartItem.type === 'loop' || recipePartItem.type === 'filter' ) &&
					Array.isArray( recipePartItem.items )
				) {
					actions.push( ...extractNestedActions( recipePartItem.items ) );
				}
			} );

			// Return the array of actions
			return actions;
		}

		// The desired array can be extracted by calling the function like so:
		const allLoopActions = extractNestedActions( this.items );

		// If the loop doesn't have any actions, stop here
		// if ( allLoopActions.length === 0 ) {
		// 	return;
		// }

		/**
		 * Step 2: Create an array with the IDs of all actions
		 */

		const allLoopActionsIDs = allLoopActions.map( item => item.id );

		/**
		 * Step 3: Get the same actions from the old object and append the already rendered elements here
		 */

		// Get actions
		const actionsFromOldObject = {
			instant: getActions( { type: 'instant', includeOnly: allLoopActionsIDs } ),
			delayed: getActions( { type: 'delayed', includeOnly: allLoopActionsIDs } ),
			scheduled: getActions( { type: 'scheduled', includeOnly: allLoopActionsIDs } ),
		}

		/**
		 * Step 4: Move/append the items
		 */

		// Create the wrappers where we're going to add the actions
		const $actionsWrappers = {
			instant:   this.querySelector( '.uap-builder-item-loop-items--instant' ),
			delayed:   this.querySelector( '.uap-builder-item-loop-items--delayed' ),
			scheduled: this.querySelector( '.uap-builder-item-loop-items--scheduled' ),
		}

		// Check if the loop has delayed actions
		let hasDelayedActions = false;

		// Iterate actions inside
		Object.entries( actionsFromOldObject ).forEach( ( [ actionType, items ] ) => {
			// Get wrapper
			const $wrapper = $actionsWrappers[ actionType ];

			// Iterate the items
			items.forEach( ( action ) => {
				// Get the node of the action
				const $actionNode = getDOMElements( 'item', {
					id: action.id,
				} ).item.get( 0 );

				// Move it inside the actions wrapper
				$wrapper.append( $actionNode );

				// Check if the action is delayed or scheduled
				if ( actionType === 'delayed' || actionType === 'scheduled' ) {
					hasDelayedActions = true;
				}
			} );
		} );

		if ( hasDelayedActions ) {
			console.log( 'Has delayed or scheduled' );
		}
	}

	/**
	 * Renders the action filters inside the loop block using the old/deprecated method
	 *
	 * @deprecated This method is deprecated and will be removed once the new recipe object is implemented
	 */
	__deprecated_renderActionFilters() { // eslint-disable-line camelcase
		/**
		 * Step 1: Get the filters of this loop from the `.conditions` object
		 * Iterate all the conditions groups and get the ones that belong to this loop by checking the parent ID
		 */
		const conditionsGroups = Object.values( UncannyAutomator.recipe.conditions )
			.filter( conditionsGroup => conditionsGroup.parentID === this.id );

		// If the loop doesn't have any filters, stop here
		if ( conditionsGroups.length === 0 ) {
			return;
		}

		/**
		 * Step 2: Render the blocks
		 */
		conditionsGroups.forEach( conditionsGroup => {
			new ConditionsBlock( {
				conditionsGroupId: conditionsGroup.id,
			} );
		} );
	}

	/**
	 * Starts the process to add a new action to the loop block
	 *
	 * @deprecated This method is deprecated and will be removed once the new recipe object is implemented
	 */
	__deprecated__startAddActionProcess() {  // eslint-disable-line camelcase
		this.insertAdjacentHTML( 'beforeend', `
			<uap-builder-item-loop-add-action
				loop-id="${ this.id }"
			></uap-builder-item-loop-add-action>
		` );
	}
}